import { marked } from "marked";

const escapedNewlinePattern = /\\r\\n|\\n|\\r/g;

export const normalizeMarkdown = (value: string): string =>
  value.replace(escapedNewlinePattern, "\n");

export const renderMarkdownHtml = (value: string): string =>
  marked.parse(normalizeMarkdown(value), {
    breaks: true,
    gfm: true,
  }) as string;
